import { useState, useEffect } from 'react';

import { BREAKPOINTS } from 'constants/breakpoints';

export type ViewportSize = 'mobile' | 'small' | 'medium' | 'large' | 'xlarge';

const getViewportSize = (): ViewportSize => {
	const width = window.innerWidth;

	if (width >= BREAKPOINTS.xlarge) return 'xlarge';
	if (width >= BREAKPOINTS.large) return 'large';
	if (width >= BREAKPOINTS.medium) return 'medium';
	if (width >= BREAKPOINTS.small) return 'small';
	return 'mobile';
};

export const useViewport = () => {
	const [viewportSize, setViewportSize] = useState<ViewportSize>(() => {
		// SSR-safe: only access window on client-side
		if (typeof window === 'undefined') {
			return 'large'; // Default for SSR
		}
		return getViewportSize();
	});

	useEffect(() => {
		const handleResize = () => {
			setViewportSize(getViewportSize());
		};

		// Only set up resize listener, initial state already set above
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return {
		viewportSize,
		isMobile: viewportSize === 'mobile' || viewportSize === 'small',
		isTablet: viewportSize === 'medium',
		isDesktop: viewportSize === 'large' || viewportSize === 'xlarge',
	};
};

